import React, { useRef, useEffect } from 'react';
// import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Form, Input, Button } from 'antd';
import {
  MailOutlined,
  LockOutlined,
  CheckOutlined,
  ArrowRightOutlined,
} from '@ant-design/icons';
import { analytics } from '../modules/analytics';

const ResetPassword = ({
  session,
  resetPassword,
  computedMatch,
}) => {

  const formRef = useRef(null);

  useEffect(() => { analytics.trackView('/reset-password'), []}); // first time load

  const prevSession = usePrevious(session);
  useEffect(() => {
    if (typeof prevSession !== 'undefined' && typeof session !== 'undefined') {
      if (prevSession.status === 'running' && session.status === 'idle') {
        injectServerErrors(session.resetFormErrors);
      }
    }
  }, [session]);
  const injectServerErrors = (formErrors) => {
    formErrors.forEach((formError) => {
      const { message, field } = formError;
      formRef.current.setFields([
        { name: field, errors: [message] },
      ]);
    });
  };

  const onFinish = (values) => {
    const { device } = session;
    resetPassword({
      ...values,
      device,
      code: computedMatch.params.code,
    });
  };

  const { status } = session;
  const isBusy = status === "running";

  return (
    <div className="auth__form_wrapper">

      <div className="auth__form_content">
        <h4>Reset Password</h4>

        <Form onFinish={onFinish} className="auth-form" ref={formRef}>

          <Form.Item name="email" rules={[
            { required: true, message: 'Email cannot be blank!' },
          ]}>
            <Input disabled={isBusy} prefix={<MailOutlined />} type="email" placeholder="Email" />
          </Form.Item>

          <Form.Item name="password" rules={[
            { required: true, message: 'Choose a password!' }
          ]}>
            <Input disabled={isBusy} prefix={<LockOutlined />} type="password" placeholder="New password" />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary" loading={isBusy} size="large" block
              icon={<CheckOutlined />} htmlType="submit"
            >
              Submit
            </Button>
          </Form.Item>

        </Form>
      </div>

      <div className="d-flex justify-content-end">
        <Link to="/forgot-password">
          <div>Resend reset link<ArrowRightOutlined className="ml-2" /></div>
        </Link>
      </div>
    </div>
  );
};

export { ResetPassword };

// export class ResetPassword extends React.Component {
//
//   constructor(props) {
//     super(props);
//     this.formRef = React.createRef();
//   }
//
//   static propTypes = {
//     session: PropTypes.shape({
//       isAuthenticated: PropTypes.bool.isRequired,
//       status: PropTypes.string.isRequired,
//       device: PropTypes.object,
//     }).isRequired,
//     resetPassword: PropTypes.func.isRequired,
//   };
//
//   componentDidMount() {
//     analytics.trackView('/resetpassword');
//   }
//
//   componentDidUpdate(prevProps) {
//     const { status: prevStatus } = prevProps.session;
//     const { status } = this.props.session;
//     if (prevStatus === 'running' && status === 'idle') {
//       this.injectServerErrors(this.props.session.resetFormErrors)
//     }
//   }
//
//   injectServerErrors = (formErrors) => {
//     formErrors.forEach((formError) => {
//       const { message, field } = formError;
//       this.formRef.current.setFields([
//         {
//           name: field,
//           errors: [message],
//         },
//       ]);
//     });
//   };
//
//   onFinish = (values) => {
//     // eventGA({ category: 'authentication', action: 'reset-password' });
//     const { device } = this.props.session;
//     this.props.resetPassword({
//       ...values,
//       device,
//       code: this.props.computedMatch.params.code,
//     });
//   };
//
//   render() {
//     const { session } = this.props;
//     const { status } = session;
//     const isBusy = status === "running";
//
//     return (
//       <div className="auth__form_wrapper">
//
//         <div className="auth__form_content">
//           <h4>Reset Password</h4>
//
//           <Form onFinish={this.onFinish} className="auth-form" ref={this.formRef}>
//
//             <Form.Item name="email" rules={[
//               { required: true, message: 'Email cannot be blank!' },
//             ]}>
//               <Input disabled={isBusy} prefix={<MailOutlined />} type="email" placeholder="Email" />
//             </Form.Item>
//
//             <Form.Item name="password" rules={[
//               { required: true, message: 'Choose a password!' }
//             ]}>
//               <Input disabled={isBusy} prefix={<LockOutlined />} type="password" placeholder="New password" />
//             </Form.Item>
//
//             <Form.Item>
//               <Button
//                 type="primary" loading={isBusy} size="large" block
//                 icon={<CheckOutlined />} htmlType="submit"
//               >
//                 Submit
//               </Button>
//             </Form.Item>
//
//           </Form>
//         </div>
//
//         <div className="d-flex justify-content-end">
//           <Link to="/forgot-password">
//             <div>Resend reset link<ArrowRightOutlined className="ml-2" /></div>
//           </Link>
//         </div>
//       </div>
//     );
//   }
// }



// WEBPACK FOOTER //
// ./scripts/presentation/ResetPassword.jsx